import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {LoadingAction, ErrorMessageAction, UpdateScheduleAction, SuccessMessageAction} from "mindsets-js-sdk";

export default function () {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const schedule = useSelector(state => state.lesson_scoring_schedule);
    const response_points = useSelector(state => state.response_points);

    return (
        <button
            className="button green"
            onClick={() => {
                if (confirm('Are you sure all the grading is correct?')) {
                    dispatch(UpdateScheduleAction(schedule.id, {status: 'QA passed'}))
                        .then(() => dispatch(SuccessMessageAction('The class has passed QA')))
                        .then(() => navigate('/lesson_schedules'))
                        .catch(error => {
                            dispatch(LoadingAction(false));
                            dispatch(ErrorMessageAction(error));
                            console.error(error);
                        });
                }
            }}
            disabled={!(!!schedule && schedule.status === 'finished' && response_points.length === response_points.filter(response_point => response_point.is_correct === true).length)}
        >Approve
        </button>
    );
}
